<template>
  <div class="py-3">
    <div class="media align-items-center">
      <div class="media-body overflow-hidden">
        <h5 class="font-size-13 mb-0 text-truncate">
          {{ $t('tabs.settings.language.title') }}
        </h5>
      </div>
      <b-dropdown
        variant="light"
        class="ml-2"
        toggle-class="btn-sm dropdown-toggle w-sm"
        right
      >
        <template v-slot:button-content>
          {{ current }}
          <i class="mdi mdi-chevron-down" />
        </template>
        <b-dropdown-item
          v-for="(name, lang) of list"
          :key="`lang-${lang}`"
          @click="changeLanguage(lang)"
        >
          {{ name }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  data: () => ({
    list: {
      en: 'English',
      ru: 'Русский',
      uk: 'Українська',
    },
  }),
  computed: {
    current() {
      return this.list[this.$store.state.locale.lang]
    },
  },
  methods: {
    ...mapActions('locale', ['changeLanguage']),
  },
}
</script>

<style scoped>

</style>
